module.exports = __webpack_public_path__ + "img/ic-index.1415fb8a.png";